import React, { ReactNode } from 'react';

// Define props interface for ConditionalRenderer component
interface ConditionalRendererProps {
  condition: boolean; // Condition to determine whether to render children
  children: ReactNode; // JSX elements or components to be conditionally rendered
}

// Functional component for conditional rendering
const ConditionalRenderer: React.FC<ConditionalRendererProps> = ({ condition, children }) => {
  // Render children if condition is true, otherwise render nothing (null)
  return condition ? <>{children}</> : null;
};

// Export ConditionalRenderer component
export default React.memo(ConditionalRenderer);
